import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { formatDistanceToNow, parseISO } from 'date-fns';
import {
  Upload, Camera, Trash2, Users, Heart, MapPin, Calendar, Phone, Mail,
  Home as HomeIcon, Church, User, UserCheck, UserX, Edit3, Plus, Pencil, Save,
  ChevronLeft, ChevronRight, X, FileText
} from 'lucide-react';

function NeedHelp() {


  const { menu, toggleMobileMenu } = useAppLayout();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const [reportMessage, setReportMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reportMessage.trim()) {
      toast.info("The message cannot be empty", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await axios.post(
        `${API_URL}/send-need-help-api`,
        { report_message: reportMessage },
        { withCredentials: true }
      );

      if (res.data.Status === "Success") {
        toast.success("Help requested", {
          position: "top-right",
          autoClose: 3000,
        });
        setReportMessage(""); // clear textarea
        queryClient.invalidateQueries(['helpRequest']);
      } else {
        toast.error(res.data.Message || "Help failed", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while submitting your Help", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  
  const [helpRequestList, sethelpRequestList] = useState([]);
  
  const {
    data: helpRequestData,
    isLoading: isHelpRequestLoading,
    isError: isHelpRequestError,
    refetch: refetchHelpRequest
  } = useQuery({
    queryKey: ['helpRequest'], 
    queryFn: () =>
      axios
        .get(`${API_URL}/get-need-help-api`, {
            
          withCredentials: true
        })
        .then(res => res.data),
   
    staleTime: 0,
    cacheTime: Infinity,
  });
  
  
  useEffect(() => {
    if (helpRequestData?.success) {
      sethelpRequestList(helpRequestData.data);
    }
  }, [helpRequestData]);
  
  
  
  const [helpRequestEditModalOpen, setHelpRequestEditModalOpen] = useState(false);
   
  const [editReportMessage, setEditReportMessage] = useState('');
  const [editId, setEditId] = useState(null);
  
  const openHelpRequestEditModal = (item) => {
   
  setEditReportMessage(item.report_message);
  setEditId(item.id);
  setHelpRequestEditModalOpen(true);
  };
  
  
  
  const [isUpdating, setIsUpdating] = useState(false);
  
  const handleUpdateNeedHelp = () => {
  if (!editReportMessage.trim()) {
    toast.info("Description are required");
    return;
  }
  
  setIsUpdating(true); // disable button
  
  axios.put(`${API_URL}/update-need-help-api/${editId}`, {
    
    report_message: editReportMessage
  }, { withCredentials: true })
    .then(() => {
      toast.success("Request updated successfully");
      setHelpRequestEditModalOpen(false);
      setEditId(null);
      setEditReportMessage('');
      queryClient.invalidateQueries(['helpRequest']);
    })
    .catch(err => {
      console.error("Error updating request description:", err);
      toast.error("Error updating request description");
    })
    .finally(() => {
      setIsUpdating(false); // enable button again
    });
  };
  
  
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);
  
  const askDeleteConfirmation = (id) => {
    setPendingDeleteId(id);
    setConfirmModalOpen(true);
  };
  
  
  
  const [isDeleting, setIsDeleting] = useState(false);
  
  const confirmDelete = () => {
  setIsDeleting(true); // disable button
  
  axios.delete(`${API_URL}/delete-need-help-api/${pendingDeleteId}`, { withCredentials: true })
    .then(() => {
      toast.success("Request deleted successfully");
      queryClient.invalidateQueries(['helpRequest']);
    })
    .catch(err => {
      console.error("Error deleting request description:", err);
      toast.error("Error deleting request description");
    })
    .finally(() => {
      setIsDeleting(false);       // enable button back
      setConfirmModalOpen(false);
      setPendingDeleteId(null);
    });
};
 



  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
    <Header onMenuClick={(value) => toggleMobileMenu()} />
    <Sidebar />
        <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">

          
          <div className="row">
              <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                    <p style={{fontWeight: '900', fontSize: '24px'}}>Need any help?  </p>
                    You can request help if you've encountered any challenge using the app.
                </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
      <div className="row">

      <div className="col-md-12">
              <div class="card">
                <div class="card-body">

        <textarea
          name="report_message"
          className="form-control"
          rows="4"
          placeholder="Describe your concern..."
          value={reportMessage}
          onChange={(e) => setReportMessage(e.target.value)}
        ></textarea>

        <button
          type="submit"
          className="btn btn-primary mt-2"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit Request"}
        </button>
      </div>
      </div>
      </div>
      </div>
    </form>



    <div>
            {helpRequestList.map(item => (
                                  <div key={item.id} className="card border-0 bg-light rounded-3 shadow-sm">
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-start justify-content-between">
                                        <div className="pe-3 flex-grow-1">
                                           
                                        <div className="text-muted lh-lg">
                                            {item.report_message}{' '}
                                            {item.resolved === 1 ? (
                                                <span className="badge bg-success ms-2">Resolved</span>
                                            ) : (
                                                <span className="badge bg-warning text-dark ms-2">Pending</span>
                                            )}
                                            </div>
                                        <div className="text-muted mb-2" style={{ fontSize: '12px' }}>
                                            {/*{item.date_time}*/}
    
                                               {item?.date_time &&
                                             !isNaN(new Date(item.date_time)) ? 
                                              formatDistanceToNow(new Date(item.date_time), { addSuffix: true }) 
                                              : ""}
    
                                        </div>
            
                                        <div className="d-flex gap-2 flex-shrink-0">
                                          <button className="btn btn-outline-success btn-sm rounded-pill d-flex align-items-center justify-content-center"
                                                   onClick={() => openHelpRequestEditModal(item)} title="Edit" style={{ width: 36, height: 36 }}>
                                            <Pencil size={16} />
                                          </button>
                                          <button className="btn btn-outline-danger btn-sm rounded-pill d-flex align-items-center justify-content-center"
                                                  onClick={() => askDeleteConfirmation(item.id)} title="Delete" style={{ width: 36, height: 36 }}>
                                            <Trash2 size={16} />
                                          </button>
                                        </div>
                                        
                                      </div>
                                    </div>
                                  </div>
                                  </div>
                                ))}
                                
        </div>
    

                    
    <ReactModal isOpen={helpRequestEditModalOpen} onRequestClose={() => setHelpRequestEditModalOpen(false)}
                        className="Modal" overlayClassName="Overlay" >
                      
                        <div className="modal-body">
                          
                      
                          <div className="mb-3">
                          <label className="form-label small fw-medium text-muted">Help description</label>
                            <textarea
                              className="form-control"
                              rows="4"
                              value={editReportMessage}
                              onChange={(e) => setEditReportMessage(e.target.value)}
                              placeholder="Describe your concern ..."
                            />
                          </div>
                        </div>
                      
                        <div className="modal-footer d-flex justify-content-between">
    
                        <button type="button" className="btn btn-outline-secondary rounded-3" 
    onClick={() => setHelpRequestEditModalOpen(false)}> Cancel </button>
    
                        <button 
                              className="btn btn-brand rounded-3 d-flex align-items-center gap-2" 
                              onClick={handleUpdateNeedHelp} 
                              disabled={isUpdating}
                            >
                              <Save size={16} /> {isUpdating ? "Updating..." : "Update"}
                            </button>
                        </div>
                      </ReactModal>
                                          
                                          
                      <ReactModal isOpen={confirmModalOpen} onRequestClose={() => setConfirmModalOpen(false)} className="Modal" overlayClassName="Overlay">
                        
                        <div className="modal-body">
                          <p>Are you sure you want to delete this help request? </p>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                          <button className="btn btn-secondary me-2" onClick={() => setConfirmModalOpen(false)}>No</button>
                          <button 
                              className="btn btn-danger" 
                              onClick={confirmDelete} 
                              disabled={isDeleting}
                            >
                              {isDeleting ? "Deleting..." : "Yes, Delete"}
                            </button>
                        </div>
                      </ReactModal>
                      


          </div>
        </div>
      </div>
   
  );
}

export default NeedHelp;
